import { createContext, Dispatch, SetStateAction } from 'react';
import { IViewChargeHistoryResponse } from '../models/responses/oms';

export type TCurrentLineItemsView = {
  transactionDetails: string;
  transaction: IViewChargeHistoryResponse['transactions'][number];
};

export interface IViewChargedDetailsContext {
  openChargedDetailsDrawer: boolean;
  setOpenChargedDetailsDrawer: Dispatch<SetStateAction<boolean>>;
  chargeHistoryData: IViewChargeHistoryResponse | undefined;
  chargeHistoryLoading: boolean;
  chargeHistoryError: Error | undefined;
  currentLineItemsView: TCurrentLineItemsView | undefined;
  setCurrentLineItemsView: Dispatch<
    SetStateAction<TCurrentLineItemsView | undefined>
  >;
}

const defaultState: IViewChargedDetailsContext = {
  openChargedDetailsDrawer: false,
  setOpenChargedDetailsDrawer: () => null,
  chargeHistoryData: undefined,
  chargeHistoryLoading: false,
  chargeHistoryError: undefined,
  currentLineItemsView: undefined,
  setCurrentLineItemsView: () => null,
};

export const ViewChargedDetailsContext =
  createContext<IViewChargedDetailsContext>(defaultState);
